{/*export const API_BASE = "https://localhost:44378/api";*/}
{/*export const API_BASE = "http://88.198.193.132/TaskManagementWebApi/api";}*/}
export const API_BASE = "http://taskmanagementwebapi.apertech.net/api";